<app-tools-catalogue-menu
  [breadcrumbLinks]="breadcrumbLinks"
></app-tools-catalogue-menu>

<div class="container m-b-xxl m-t-alt">
  <div class="columns is-multiline">
    <div class="column is-12">
      <h1 class="title is-2 mb-0">
        Why we need a catalogue of tools and metrics for trustworthy AI
      </h1>
    </div>
  </div>
  <div class="columns">
    <div class="column">
      There are tools and metrics out there that help AI actors to build and
      deploy AI systems that are trustworthy. However, these tools and metrics
      are often hard to find and absent from the ongoing AI policy discussions.
      This catalogue makes it easier to find tools and metrics by providing a
      one-stop-shop for helpful approaches, mechanisms and practices for
      trustworthy AI.
    </div>
  </div>

  <!-- Cards -->
  <div class="columns is-multiline">
    <div class="column is-6">
      <div
        class="card pointer has-background-white-ter no-border is-full-height"
      >
        <a class="no-deco has-text-primary" routerLink="/catalogue/tools">
          <div>
            <div class="media mb-0">
              <div class="media-left">
                <figure class="image is-32x32">
                  <div class="icon-wrapper mr-2">
                    <div class="has-background-danger-bis"></div>
                    <span class="icon is-size-6">
                      <i class="fas fa-th-large has-text-danger-bis"></i>
                    </span>
                  </div>
                </figure>
              </div>
              <div class="media-content">
                <h2 class="title is-4 mt-2 mb-3">Tools</h2>
              </div>
            </div>
            <div class="content is-small">
              <p class="mt-0 mb-1 has-text-black-bis">
                Find a tool that fits your specific needs
              </p>
              <span>
                <i class="fas fa-arrow-alt-circle-right has-text-link mr-2"></i
                ><a routerLink="/catalogue/tools"
                  >See all tools and related use cases</a
                ></span
              >
            </div>
          </div>
        </a>
      </div>
    </div>

    <div class="column is-6">
      <div
        class="card pointer has-background-white-ter no-border is-full-height"
      >
        <a class="no-deco has-text-primary" routerLink="/catalogue/metrics">
          <div>
            <div class="media mb-0">
              <div class="media-left">
                <figure class="image is-32x32">
                  <div class="icon-wrapper mr-2">
                    <div class="has-background-color-purple"></div>
                    <span class="icon is-size-6">
                      <i class="fas fa-puzzle-piece has-text-color-purple"></i>
                    </span>
                  </div>
                </figure>
              </div>
              <div class="media-content">
                <h2 class="title is-4 mt-2 mb-3">Metrics</h2>
              </div>
            </div>
            <div class="content is-small">
              <p class="mt-0 mb-1 has-text-black-bis">
                Explore metrics to evaluate how AI systems align with
                trustworthy AI Principles
              </p>
              <span
                ><i class="fas fa-arrow-alt-circle-right has-text-link mr-2"></i
                ><a routerLink="/catalogue/metrics"
                  >See all metrics and related uses cases</a
                ></span
              >
            </div>
          </div>
        </a>
      </div>
    </div>
  </div>

  <!-- Taxonomy list -->
  <div class="columns is-multiline" *ngFor="let searchGroup of searchGroups">
    <div class="column is-12 pb-0">
      <h3 class="title is-3 mb-0 mt-6">{{ searchGroup.name }}</h3>
    </div>

    <div class="column is-6 pb-0" *ngFor="let search of searchGroup.searches">
      <span
        ><em class="icon icon-Right m-r-sm has-text-link is-size-7"></em
        ><a [routerLink]="[search.path]" [queryParams]="search.queryParams">{{
          search.name
        }}</a></span
      >
    </div>
  </div>
</div>

<app-tools-catalogue-disclaimer></app-tools-catalogue-disclaimer>
